<template>
  <a-modal v-model="visible" :footer="null" class="chpwdfrm" :afterClose="close" :destroyOnClose="true" key="chpwdFrm" :width="340">
    <div class="title">
      修改密码
    </div>
    <div class="content">

      <a-form :autoFormCreate="(form)=>{this.form = form}">
        <a-form-item fieldDecoratorId="passwordOld" :fieldDecoratorOptions="{rules: [{ required: true, message: '请输入你的旧密码' }]}">
          <a-input addonBefore="旧密码" placeholder='请输入你的旧密码' size="large" type="password" />
        </a-form-item>
        <a-form-item fieldDecoratorId="passwordNew" :fieldDecoratorOptions="{rules: [{ required: true, message: '请输入你的新密码' }]}">
          <a-input addonBefore="新密码" placeholder='请输入你的新密码' size="large" type="password" />
        </a-form-item>
        <a-form-item fieldDecoratorId="verifycode" class="passwordConfirm" :fieldDecoratorOptions="{rules: [{ required: true, message: '请再次输入新密码' }, { validator: compareToFirstPassword }]}">
          <a-input addonBefore="确认密码" placeholder='请再次输入新密码' size="large" type="password" />
        </a-form-item>
        <a-form-item>
          <a-button @click="submitHandle" type='primary' style="width:100%;" size="large">确认修改</a-button>
        </a-form-item>
      </a-form>
    </div>
  </a-modal>
</template>
<script>
export default {
  data() {
    return {
      visible: true,
      form: null
    };
  },
  props: {
    close: Function,
    success: Function
  },
  methods: {
    compareToFirstPassword(rule, value, callback) {
      const form = this.form;
      if (value && value !== form.getFieldValue("passwordNew")) {
        callback("两次输入的密码不一致!");
      } else {
        callback();
      }
    },
    submitHandle() {
      this.form.validateFields((err, value) => {
        if (!err) {
          this.$http
            .post("/passwordEdit", value)
            .then(res => {
              if (!res.error) {
                this.$message.success("密码修改成功");
                this.visible = false;
                this.success && this.success();
              } else {
                this.$message.error(res.errorMsg || "修改失败");
              }
            })
            .catch(e => this.$message.error(e));
        }
      });
    }
  }
};
</script>
<style lang="scss" >
.chpwdfrm {
  .ant-modal-content {
    .ant-modal-body {
      padding: 0;
      .ant-form-item:last-child {
        margin-bottom: 0;
      }
    }
  }
  .title {
    padding: 15px;
    font-size: 15px;
    background-color: #f6fcff;
    box-shadow: 0px 5px 5px #ddf0fb;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
  }
  .content {
    padding: 15px;
    .ant-btn,
    .ant-input,
    .ant-input-group-addon {
      font-size: 13px;
      border-radius: 0;
    }
  }
}
</style>
